import * as React from "react";

import {
    css,
    Theme,
} from "@bdfx/mergado-ui-kit";


interface Props {
    color?: string
    className?: string
    style?: any
    children?: React.JSX.Element
}

class DoubleScrollBar extends React.PureComponent<Props> {
    scrollBarTop: React.RefObject<HTMLDivElement>
    scrollBarBottom: React.RefObject<HTMLDivElement>
    scrollBarTopChild: React.RefObject<HTMLDivElement>

    constructor(props) {
        super(props)

        this.scrollBarTop = React.createRef()
        this.scrollBarBottom = React.createRef()
        this.scrollBarTopChild = React.createRef()
    }

    handleScrollContent = (event) => {
        this.scrollBarTop.current.scrollLeft = event.target.scrollLeft
        this.scrollBarBottom.current.scrollLeft = event.target.scrollLeft
    }

    componentDidMount() {
        this.scrollBarTopChild.current.style.width = `${this.scrollBarBottom.current.scrollWidth}px`
        this.scrollBarTop.current.addEventListener('scroll', this.handleScrollContent)
        this.scrollBarBottom.current.addEventListener('scroll', this.handleScrollContent)
    }

    componentWillUnmount() {
        this.scrollBarTop.current.removeEventListener('scroll', this.handleScrollContent)
        this.scrollBarBottom.current.removeEventListener('scroll', this.handleScrollContent)
    }

    render() {
        const {children, style, color, className, ...others} = this.props

        const contentDivProps = {
            className,
            style: {
                ...others,
                ...style,
            }
        }

        const addStyles = {
            '&::-webkit-scrollbar': {
                width: '8px',
                height: '8px',
            },
            '&::-webkit-scrollbar-track': {
                boxShadow: 'inset 0 0 2px grey',
                borderRadius: '10px',
            },
            '&::-webkit-scrollbar-thumb': {
                background: color ? color : Theme.steelblue,
                borderRadius: '10px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
                background: color ? color : Theme.steelblue,
            }
        }

        return React.createElement(React.Fragment, null,
            React.createElement(StyledTopDiv, {ref: this.scrollBarTop, style: addStyles}, React.createElement(StyledTopDivChild, {ref: this.scrollBarTopChild})),
            React.createElement(StyledBottomDiv, {ref: this.scrollBarBottom,  style: addStyles}, React.createElement(ContentDiv, contentDivProps, children)),
        );
    }
}

const StyledTopDiv = css("div")({
    overflowX: 'auto',
    marginBottom: '5px',
})

const StyledTopDivChild = css("div")({
    height: '1px'
})

const StyledBottomDiv = css("div")({
    overflowX: 'auto',
})

const ContentDiv = css("div")({
})

export default DoubleScrollBar
